module.exports = "<div class=\"content-padding wordpress\" [innerHTML]=\"page?.content?.rendered\">\n</div>"